import React from 'react';
import styled from 'styled-components';
import { RebelColors } from '../../../../styles/rebel-experiences';

/**
 * Dropdown for ranking REBEL experiences
 * Prevents duplicate rankings across experiences
 * @param {string} experienceId - The experience ID this dropdown is for
 * @param {object} selectedRankings - All current rankings { expId: rank }
 * @param {function} onChange - Callback when ranking changes (expId, newRank)
 * @param {number} totalExperiences - Total number of experiences to rank
 */
const RankingDropdown = ({ experienceId, selectedRankings, onChange, totalExperiences }) => {

    const currentRank = selectedRankings[experienceId] || '';

    // Check if a rank is taken by another experience
    const isRankTaken = (rank) => {
        return Object.entries(selectedRankings).some(
            ([expId, selectedRank]) =>
                expId !== experienceId && parseInt(selectedRank) === parseInt(rank)
        );
    };

    const handleChange = (e) => {
        const value = e.target.value;
        onChange(experienceId, value === '' ? null : parseInt(value));
    };

    return (
        <DropdownContainer>
            <RankingSelect
                value={currentRank}
                onChange={handleChange}
                hasSelection={currentRank !== ''}
            >
                <option value="">Select Rank</option>
                {Array.from({ length: totalExperiences }, (_, i) => i + 1).map(rank => (
                    <option
                        key={rank}
                        value={rank}
                        disabled={isRankTaken(rank)}
                    >
                        {rank}{isRankTaken(rank) ? ' (taken)' : ''}
                    </option>
                ))}
            </RankingSelect>
        </DropdownContainer>
    );
};

export default RankingDropdown;

const DropdownContainer = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100%;
`;

const RankingSelect = styled.select`
    width: 80px;
    padding: 7px 8px;
    margin: 0;
    border: 2px solid ${props => props.hasSelection ? RebelColors.gold : RebelColors.border};
    background-color: ${RebelColors.surface};
    color: ${RebelColors.primary};
    border-radius: 4px;
    font-size: 0.95rem;
    line-height: 1.2;
    cursor: pointer;
    transition: all 0.3s ease;
    height: 36px;
    text-align: center;
    text-align-last: center;

    &:focus {
        outline: none;
        border-color: ${RebelColors.gold};
        box-shadow: 0 0 0 2px ${RebelColors.gold}22;
    }

    &:hover {
        border-color: ${RebelColors.gold};
    }

    &:disabled {
        cursor: not-allowed;
        opacity: 0.5;
    }

    option {
        background-color: ${RebelColors.surface};
        color: ${RebelColors.primary};
    }

    option:disabled {
        color: #666;
        font-style: italic;
    }
`;
